<template>
  <div :class="[' text-xl leading-none']">
    <client-only>
      <NuxtLink
        :to="switchLanguageUrl"
        @click="handleLanguageSwitch"
        class="hidden lg:inline-flex items-center cursor-pointer font-medium"
      >
        <span class="mr-3 text-xl">no</span>
        <div
          :class="[
            'relative  w-10 h-5 bg-light peer-focus:outline-none rounded-full peer',
            `after:content-[''] after:absolute after:start-0 after:bg-primary after:border-primary after:border after:rounded-full after:h-5 after:w-5 after:transition-all`,
            {
              'after:translate-x-full': language !== 'no',
            },
          ]"
        ></div>
        <span class="ml-3 text-xl">en</span>
      </NuxtLink>
      <NuxtLink
        :to="switchLanguageUrl"
        @click="handleLanguageSwitch"
        class="inline-flex lg:hidden items-center cursor-pointer font-medium"
      >
        <Icon name="Language" class="mr-2" /><span class="mr-3 text-xl">{{
          language !== 'no' ? 'NO' : 'EN'
        }}</span>
      </NuxtLink>
    </client-only>
  </div>
</template>

<script setup>
import { parseStoryblokFullSlug } from '~/composables/storyblokLink';
import { computed } from 'vue';

defineProps({ mobile: Boolean });

const langOptions = ['en', 'no'];
const language = useState('language');
const alternates = useState('alternates');

// find the alternate language for the current page
const alternate = computed(() => alternates.value?.find((alt) => alt.lang !== language.value));
const alternateLanguage = computed(() => langOptions.find((lang) => lang !== language.value));
const alternateUrl = computed(() => (alternate.value ? alternate.value.full_slug : null));

const runtimeConfig = useRuntimeConfig();

const switchLanguageUrl = computed(() => {
  if (!alternateUrl.value) {
    // Note: to prevent hydration missmatch with storyblok slug url on homepage, appended ending slash
    return alternateLanguage.value === 'no'
      ? `${runtimeConfig.public.siteUrl}/`
      : `${runtimeConfig.public.siteUrl}/en/`;
  }
  return parseStoryblokFullSlug(alternateUrl.value);
});

const handleLanguageSwitch = () => {
  console.log('settings language to', alternateLanguage.value, alternates.value);
  language.value = alternateLanguage.value;
};
</script>

<style scoped>
.select-dropdown {
  @apply text-white bg-black;
}

.select-dropdown option {
  @apply text-black bg-white;
}

.select-dropdown option:checked {
  @apply text-white bg-black;
}
</style>
